export const resourcesData = [
  {
    id: 1,
    category: "Learning Materials",
    iconKey: "book",
    color: "from-blue-500 to-cyan-500",
    items: [
      {
        name: "Kali Linux Revealed (Official Book)",
        type: "PDF",
        size: "Free",
        link: "https://upload.wikimedia.org/wikipedia/commons/5/5d/Kali-Linux-Revealed-2021-edition.pdf",
      },
      {
        name: "OWASP Web Security Testing Guide v4 (PDF)",
        type: "PDF",
        size: "Free",
        link: "https://owasp.org/www-project-web-security-testing-guide/assets/archive/OWASP_Testing_Guide_v4.pdf",
      },
      {
        name: "NIST SP 800-53 Rev.5 (Security Controls)",
        type: "PDF",
        size: "Free",
        link: "https://nvlpubs.nist.gov/nistpubs/SpecialPublications/NIST.SP.800-53r5.pdf",
      },
      {
        name: "Kali Linux Official Documentation",
        type: "Docs",
        size: "Free",
        link: "https://www.kali.org/docs/",
      },
    ],
  },

  {
    id: 2,
    category: "Video Tutorials",
    iconKey: "video",
    color: "from-purple-500 to-pink-500",
    items: [
      {
        name: "Kali Linux (Official YouTube)",
        type: "Playlist",
        duration: "Free",
        link: "https://youtu.be/W013Y3UInoQ?si=EiA2WimW38H6LwRN",
      },
      {
        name: "OWASP Foundation (YouTube)",
        type: "Video",
        duration: "Free",
        link: "https://youtu.be/j5PuYFCS0Iw?si=HTX9WVTv_osST6dn",
      },
      {
        name: "NIST CSRC Publications (Docs)",
        type: "Website",
        duration: "Free",
        link: "https://csrc.nist.gov/publications",
      },
      {
        name: "OWASP WSTG v4.2 (Web)",
        type: "Website",
        duration: "Free",
        link: "https://owasp.org/www-project-web-security-testing-guide/v42/",
      },
    ],
  },

  {
    id: 3,
    category: "Cheat Sheets",
    iconKey: "pdf",
    color: "from-green-500 to-emerald-500",
    items: [
      {
        name: "OWASP Cheat Sheet Series (Official)",
        type: "Website",
        pages: "Free",
        link: "https://cheatsheetseries.owasp.org/",
      },
      {
        name: "Linux Command Cheat Sheet (PDF - Loggly)",
        type: "PDF",
        pages: "2",
        link: "https://www.loggly.com/wp-content/uploads/2015/05/Linux-Cheat-Sheet-Sponsored-By-Loggly.pdf",
      },
      {
        name: "Linux Command Line Cheat Sheet (PDF)",
        type: "PDF",
        pages: "8+",
        link: "https://personales.unican.es/corcuerp/linux/resources/LinuxCommandLineCheatSheet_1.pdf",
      },
      {
        name: "Linux Commands Cheat Sheet (PhoenixNAP)",
        type: "Website",
        pages: "Free",
        link: "https://phoenixnap.com/kb/linux-commands-cheat-sheet",
      },
    ],
  },

  {
    id: 4,
    category: "Training Courses",
    iconKey: "graduation",
    color: "from-yellow-500 to-amber-500",
    items: [
      {
        name: "NIST Cybersecurity Framework",
        type: "Course",
        duration: "Free",
        link: "https://www.nist.gov/cyberframework",
      },
      {
        name: "Kali Linux Docs & Learning",
        type: "Course",
        duration: "Free",
        link: "https://www.kali.org/docs/",
      },
      {
        name: "OWASP Resources",
        type: "Guide",
        duration: "Free",
        link: "https://owasp.org/",
      },
      {
        name: "OWASP WSTG Learning",
        type: "Guide",
        duration: "Free",
        link: "https://owasp.org/www-project-web-security-testing-guide/",
      },
    ],
  },

  {
    id: 5,
    category: "Tool Documentation",
    iconKey: "docs",
    color: "from-red-500 to-orange-500",
    items: [
      {
        name: "Kali Tools List (Official)",
        type: "Docs",
        updated: "Official",
        link: "https://www.kali.org/tools/",
      },
      {
        name: "OWASP Projects Documentation",
        type: "Docs",
        updated: "Official",
        link: "https://owasp.org/projects/",
      },
      {
        name: "NIST CSRC Docs",
        type: "Docs",
        updated: "Official",
        link: "https://csrc.nist.gov/publications",
      },
      {
        name: "OWASP WSTG Project",
        type: "Docs",
        updated: "Official",
        link: "https://owasp.org/www-project-web-security-testing-guide/",
      },
    ],
  },

  {
    id: 6,
    category: "Code Templates",
    iconKey: "code",
    color: "from-indigo-500 to-purple-500",
    items: [
      {
        name: "OWASP WSTG (GitHub)",
        type: "Code",
        language: "GitHub",
        link: "https://github.com/OWASP/wstg",
      },
      {
        name: "NIST OSCAL (GitHub)",
        type: "Code",
        language: "GitHub",
        link: "https://github.com/usnistgov/OSCAL",
      },
      {
        name: "OWASP Cheat Sheet Series",
        type: "Code",
        language: "Web",
        link: "https://cheatsheetseries.owasp.org/",
      },
      {
        name: "Kali Tools (Official List)",
        type: "Code",
        language: "Linux",
        link: "https://www.kali.org/tools/",
      },
    ],
  },
];
